/** Full-page terminal detail URL (opens in app router). */
export const getTerminalDetailPath = (terminalId: string): string =>
  `/admin/terminal-management/${encodeURIComponent(terminalId)}`;

/** Open the terminal detail page in a new browser tab. */
export const openTerminalDetailInNewTab = (terminalId: string): void => {
  window.open(getTerminalDetailPath(terminalId), '_blank', 'noopener,noreferrer');
};
